<template lang="html">
  <div class="receive-tasks-page">
      <div class="search-form">
          <el-form label-position="left" label-width="130px" :model="form">
              <el-row>
                  <el-col :span="7">
                      <el-form-item>
                        <div slot="label" class="form-label">
                            任务名称:
                        </div>
                        <el-input v-model="form.job_name" placeholder="请输入" maxlength=20 clearable></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col :span="7" :offset="1">
                      <el-form-item>
                        <div slot="label" class="form-label">
                            任务ID:
                        </div>
                        <el-input v-model="form.job_id" placeholder="请输入" maxlength=10 clearable></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col :span="7" :offset="1">
                      <el-form-item>
                        <div slot="label" class="form-label">
                            手机号:
                        </div>
                        <el-input v-model="form.user_phone" placeholder="请输入" clearable></el-input>
                      </el-form-item>
                  </el-col>
              </el-row>
              <el-row>
                  <el-col :span="7">
                      <el-form-item>
                        <div slot="label" class="form-label">
                            批改人:
                        </div>
                        <el-input v-model="form.correct_user" placeholder="请输入" maxlength=20 clearable></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col :span="7" :offset="1">
                      <el-form-item>
                        <div slot="label" class="form-label">
                            批改名称:
                        </div>
                        <el-input v-model="form.correct_name" placeholder="请输入" maxlength=20 clearable></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col :span="7" :offset="1">
                      <el-form-item>
                        <div slot="label" class="form-label">
                            批改状态:
                        </div>
                        <el-select v-model="form.correct_status" clearable placeholder="请选择" class="my-select">
                            <el-option
                              v-for="item in statusOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                        </el-select>
                      </el-form-item>
                  </el-col>
              </el-row>
              <el-row>
                  <el-col :span="7">
                      <el-form-item>
                        <div slot="label" class="form-label">
                            批改时限:
                        </div>
                        <el-select v-model="form.correct_time_limit" clearable placeholder="请选择" class="my-select">
                            <el-option
                              v-for="item in timeOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                        </el-select>
                      </el-form-item>
                  </el-col>
                  <el-col :span="7" :offset="1">
                      <el-form-item>
                        <div slot="label" class="form-label">
                            批改范围:
                        </div>
                        <el-select v-model="form.correct_gauge" clearable placeholder="请选择" class="my-select">
                            <el-option
                              v-for="item in limitsOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                        </el-select>
                      </el-form-item>
                  </el-col>
                  <el-col :span="7" :offset="1">
                      <el-form-item>
                        <div slot="label" class="form-label">
                            使用时间:
                        </div>
                        <el-date-picker
                          class="my-select"
                          v-model="form.correct_time"
                          type="datetimerange"
                          align="right"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          format="yyyy-MM-dd HH:mm:ss"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          :default-time="['12:00:00', '12:00:00']">
                        </el-date-picker>
                      </el-form-item>
                  </el-col>
                  <el-col :span="7">
                      <el-form-item>
                        <div slot="label" class="form-label">
                            批改任务来源:
                        </div>
                        <el-select v-model="form.job_from" clearable placeholder="请选择" class="my-select">
                            <el-option
                              v-for="item in fromOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                        </el-select>
                      </el-form-item>
                  </el-col>
              </el-row>
              <el-row>
                  <el-col :span="7" :offset="16">
                      <div class="button-group">
                          <el-button type="primary" @click="search">查询</el-button>
                          <el-button @click="initForm">重置</el-button>
                      </div>
                  </el-col>
              </el-row>
          </el-form>
      </div>
      <div class="result-table">
          <el-table
              :data="tableData"
              style="width: 100%">
              <el-table-column
                prop="job_name"
                label="任务"
                width="180">
                <template slot-scope="scope">
                  <el-tooltip placement="top" v-if="charLength(`【${scope.row.job_id}】${scope.row.job_name}`) > 44">
                      <div slot="content" :style="{width: '180px'}">{{`【${scope.row.job_id}】${scope.row.job_name}`}}</div>
                      <div class="line-clamp">{{`【${scope.row.job_id}】${scope.row.job_name}`}}</div>
                  </el-tooltip>
                  <div v-else>
                    {{`【${scope.row.job_id}】${scope.row.job_name}`}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="correct_name"
                label="批改名称"
                width="180">
                <template slot-scope="scope">
                  <el-tooltip placement="top" v-if="charLength(scope.row.correct_name) > 44">
                      <div slot="content" :style="{width: '180px'}">{{scope.row.correct_name}}</div>
                      <div class="line-clamp">{{scope.row.correct_name}}</div>
                  </el-tooltip>
                  <div v-else>
                    {{scope.row.correct_name}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="学员信息">
                <template slot-scope="scope">
                    <div>{{scope.row.user_name}}</div>
                    <div>{{scope.row.user_phone}}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="user_correct_time_format"
                width="180"
                label="使用时间">
              </el-table-column>
              <el-table-column
                prop="remaining_time"
                label="剩余批改时间">
                <template slot-scope="scope">
                    <div>{{scope.row.remaining_time}}</div>
                    <div v-if="scope.row.is_notice" class="warn-word">{{`<${scope.row.notice_hours}h`}}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="correct_gauge_chinese"
                label="批改范围">
              </el-table-column>
              <el-table-column
                prop="correct_user"
                label="批改人">
                <template slot-scope="scope">
                  <div>{{scope.row.correct_user || '-'}}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="correct_user"
                label="批改任务来源">
                <template slot-scope="scope">
                  <div v-if='scope.row.job_from'>
                    <p v-if='scope.row.job_from == 1'>课程商品</p>
                    <p v-else-if='scope.row.job_from == 2'>批改商品</p>
                    <p v-else-if='scope.row.job_from == 3'>面授商品</p>
                    <p v-else-if='scope.row.job_from == 4'>图书商品</p>
                    <p v-else-if='scope.row.job_from == 5'>双师课程</p>
                    <p v-else-if='scope.row.job_from == 6'>19商品</p>
                  </div>
                  <div v-else>-</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="correct_status"
                label="批改状态">
                <template slot-scope="scope">
                  <div style="display: none">{{ scope.row.correct_status }}{{ scope.row.correct_status == 0 }}{{ scope.row.correct_status == 1 }}{{ scope.row.correct_status == 1 }}</div>
                  <div style="display: none">{{ scope.row.correct_user }}{{user_no}}{{scope.row.correct_user  == user_no}}</div>
                  <div v-if="scope.row.correct_status == 0">
                    <div>未批改</div>
                    <span class="blue" @click="receiveTask(scope.row, 1)">去认领</span>
                  </div>
                  <div v-if="scope.row.correct_status == 1">
                    <div>批改中</div>
                    <span class="blue" v-if="scope.row.correct_user == user_no"><span @click="goInfo(scope.row, 1)">去批改</span> | <span @click="receiveTask(scope.row, 2)">取消认领</span></span>
                    <!-- <span class="blue"><span>去批改</span> | <span>取消认领</span></span> -->
                  </div>
                  <div v-if="scope.row.correct_status == 2">
                    <div>批改完成</div>
                    <span class="blue" v-if="scope.row.correct_user == user_no" @click="goInfo(scope.row, 2)">修改批改结果</span>
                    <span class="blue" v-if="scope.row.correct_user != user_no" @click="goInfo(scope.row, 3)">查看批改结果</span>
                  </div>
                </template>
              </el-table-column>
          </el-table>
          <div class="paginationblock" v-if="tableData.length">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageInfo.page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageInfo.page_size"
              layout="prev, pager, next, sizes, jumper"
              :total="pageInfo.total">
            </el-pagination>
          </div>
      </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            // 批改范围选项
            limitsOptions: [
                {
                    label: '作文题',
                    value: '1'
                },
                {
                    label: '非作文题',
                    value: '2'
                },
                {
                    label: '套卷',
                    value: '3'
                },
            ],
            // 批改时限选项
            timeOptions: [
                {
                    label: '普通',
                    value: '0'
                },
                {
                    label: '加急',
                    value: '1'
                },
            ],
            // 批改状态选项
            statusOptions: [
                {
                    label: '未批改',
                    value: '0'
                },
                {
                    label: '批改中',
                    value: '1'
                },
                {
                    label: '已批改',
                    value: '2'
                }
            ],
            // 任务来源选项
            fromOptions: [],
            form: {},
            tableData: [],
            pageInfo: {
                page_size: 20,
                page: 1,
                total: 10
            },
            // 用户工号
            user_no: '',
        }
    },
    created () {
      // 获取用户工号
      this.user_no = window.localStorage.getItem('user_no');
      this.getParamsOptions(() => {
        this.search();
      });
    },
    methods: {
        //获取字符串的真实长度
        charLength (str) {
          var realLength = 0, len = str.length, charCode = -1;
          for (var i = 0; i < len; i++) {
            charCode = str.charCodeAt(i);
            if (charCode >= 0 && charCode <= 255) {
              realLength += 1;
            } else {
              realLength += 2;
            }
          }
          return realLength;
        },
        // 获取搜索条件配置
        getParamsOptions (cb) {
          this.$api.GETPARAMSOPTIONS().then(res => {
            console.log(res);
            if (res.retcode == 0) {
              this.limitsOptions = res.data.correct_gauge.map(item => {
                return {
                  label: item.name,
                  value: item.id
                }
              });
              this.timeOptions = res.data.correct_time_limit.map(item => {
                return {
                  label: item.name,
                  value: item.id
                }
              });
              this.statusOptions = res.data.correct_status.map(item => {
                return {
                  label: item.name,
                  value: item.id
                }
              });
              this.fromOptions = res.data.job_from_list.map(item => {
                return {
                  label: item.name,
                  value: item.id
                }
              });
              cb && cb();
            } else {
              this.$message.error(res.message);
            }
          })
        },
        // 查询
        search () {
            console.log('search');
            this.pageInfo.page = 1;
            this.getTaskList();
        },
        // 重置
        initForm () {
            console.log('initForm');
            this.form = {};
            this.pageInfo.page = 1;
            this.getTaskList();
        },
        //更改每页显示多少条数据时调用
        handleSizeChange (val) {
            this.pageInfo.page_size = val;
            this.search();
        },
        // 更新当前页码
        handleCurrentChange (val) {
            this.pageInfo.page = val;
            this.getTaskList();
        },
        // 获取列表
        getTaskList () {
          if (this.form.correct_time && this.form.correct_time.length) {
            this.form.correct_time_start = this.form.correct_time[0];
            this.form.correct_time_end = this.form.correct_time[1];
          }
          var params = {...this.form, ...this.pageInfo};
          if (params.correct_time) {
            delete params.correct_time;
          }
          this.$api.GETCORRECTLIST(params).then((res) => {
              if(res.retcode==0){
                  this.tableData = res.data.list;
                  this.pageInfo.total = res.data.total_num;
              }else{
                  this.$message.error(res.message);
              }

          })
        },
        // 领取任务&&取消认领
        receiveTask(task, action) {
          console.log('task', task);
          var params = {
            job_id: task.job_id,
            action: action // 1:领取 2:取消领取
          };
          this.$api.RECEIVETASK(params).then((res) => {
            console.log('领取任务结果', res);
            if (res.retcode == 0) {
              this.tableData = this.tableData.map(item => {
                if (item.job_id == task.job_id) {
                  if (action == 1) {
                    item.correct_status = 1
                    item.correct_user = this.user_no
                  } else {
                    item.correct_status = 0
                    item.correct_user = ''
                  }
                }
                return item;
              })
              this.$message({
                message: action == 1 ? '任务领取成功' : '取消任务成功',
                type: 'success'
              });
            } else if (res.retcode == 10009) {
              this.$confirm('<p style="color:#bbb;">任务状态已发生改变，请刷新后重试</p>', '任务状态已发生改变', {
                confirmButtonText: '我知道了',
                cancelButtonText: '',
                type: 'warning',
                showClose:false,
                closeOnClickModal:false,
                dangerouslyUseHTMLString:true,
                showCancelButton:false
              }).then(() => {
                  console.log('任务状态已发生改变');
                  this.$router.go(0);
              }).catch(() => {
              });
            } else {
              this.$confirm('', res.message, {
                confirmButtonText: '我知道了',
                type: 'warning',
                center: true,
                showClose:false,
                showCancelButton: false
              }).then(() => {
              }).catch(() => {
              });
            }
          })
        },
        goInfo(task, type) {
          // type 1.去批改 2.修改 3.查看
          window.localStorage.setItem('paper_name',task.job_name);
          this.$router.push(`/task-info/${task.correct_user}/${task.user_record_id}/${task.job_id}/${task.object_id}/${task.object_type}/${task.orgin}/${type}`);
        }

    }
}
</script>

<style lang="less" scoped>
    .receive-tasks-page {
        .search-form {
            background-color: #fff;
            padding: 22px 0;
            .form-label {
                text-align: right;
                padding-right: 10px;
            }
            .my-select {
                width: 100%;
            }
            .button-group {
                display: flex;
                justify-content: flex-end;
            }
        }
        .result-table {
            margin-top: 22px;
            .paginationblock{
              padding: 20px 0;
              text-align: right;
              background-color: #fff;
            }
            .line-clamp {
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
            .warn-word {
              color: red;
            }
            .blue{
                color: #1890ff;
                cursor: pointer;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/receive-tasks/index.vue